/**
 * APM性能监控
 */
import { getUser, loadScript } from "../../utils"
import { getCookie } from "../cookie"

const environment = getCookie("fed-env")
const BUSINESSCENTER: any = { 10: "成都", 20: "深合" }
declare const window: any

type Options = {
  version: string
  serviceName: string
}
const init = (options: Options) => {
  const { version, serviceName } = options
  if (!version || !serviceName) {
    return
  }
  loadScript(
    "//hz.huizecdn.com/js/hz/hzcomm/apm-js-sdk/elastic-apm-rum.umd.min.js",
  ).then(() => {
    const { elasticApm } = window
    const {
      businessCenter,
      employeeWorkCode: id,
      employeeName: username,
    } = getUser()
    let serverUrl: string = "//apm-collect-dev.hzins.net"

    switch (environment) {
      case "test":
        serverUrl = "//apm-collect-test.hzins.net" // 测试环境
        break
      case "preview":
        serverUrl = "//apm-collect-pre.hzins.net/" // P版
        break
      case "production":
        serverUrl = "//apm-collect.hzins.net" // 生产环境
        break
      default:
    }

    const serviceVersion = version
    const apm = elasticApm.init({
      serviceName, // 应用名称
      serverUrl, // 服务地址，区分开发环境，P版，外网
      serviceVersion,
      // 根据页面路由做聚合分类 antd pro 不需要设置这里
      // pageLoadTransactionName: appPathName,
      // 使用公司的环境配置，不能直接读process.env，会在编译阶段处理替换掉
      environment,
    })
    // 添加用户标识
    const context = { id, username }
    apm.setUserContext(context)
    apm.addLabels({ businessCenter: BUSINESSCENTER[businessCenter || 0] })
    // eslint-disable-next-line func-names
    apm.observe("transaction:end", function (transaction: { name: string }) {
      if (transaction.name === "Unknown") {
        // eslint-disable-next-line no-param-reassign
        transaction.name = window.location.pathname
      }
    })
  })
}

export default init
